export enum EventStoreError {
  ADD_EVENT_ERROR = "Error adding traffic impact Event",
  DELETE_EVENT_ERROR = "Error deleting traffic impact Event",
  GET_EVENT_ERROR = "Error getting traffic impact Event",
  GET_EVENTS_ERROR = "Error getting traffic impact Events",
  UPDATE_EVENT_ERROR = "Error updating traffic impact Event",
}

export enum EventStoreSuccess {
  ADD_EVENT_SUCCESS = "Success adding traffic impact Event",
  DELETE_EVENT_SUCCESS = "Success deleting traffic impact Event",
  GET_EVENT_SUCCESS = "Success getting traffic impact Event",
  GET_EVENTS_SUCCESS = "Success getting traffic impact Events",
  UPDATE_EVENT_SUCCESS = "Success updating traffic impact Event",
}
